import styled from 'styled-components';

const ButtonText = styled.span`
  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '15px')};
  font-family: ${({ bold }) => (bold ? '"Avenir Black", "Arial Black"' : '"Avenir Light", "Arial"')}, sans-serif;
  ${({ noSpacing }) => (noSpacing ? null : 'letter-spacing: 1px;')};
  ${({ marginText }) => (marginText ? `margin: ${marginText}` : null)};
`;

export default ButtonText;
